import { render, staticRenderFns } from "./editPurchaseOrder.vue?vue&type=template&id=36bbb947&scoped=true"
import script from "./editPurchaseOrder.vue?vue&type=script&lang=js"
export * from "./editPurchaseOrder.vue?vue&type=script&lang=js"
import style0 from "./editPurchaseOrder.vue?vue&type=style&index=0&id=36bbb947&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bbb947",
  null
  
)

export default component.exports